import { keymap } from '@atlaskit/editor-common/keymaps';
import { EditorState } from '@atlaskit/editor-prosemirror/state';

import {
  focusOnCodeSuggestionsEditor,
  getAllNodePositions,
  isCodeSuggestionNode,
} from '../utils';

const handleArrowNavigation = (
  state: EditorState,
  direction: 'up' | 'down'
) => {
  const { $from } = state.selection;
  const { nodePositions } = getAllNodePositions(state);

  // This gets the position of the *current block* where the selection is.
  // `.before(1)` gets the position of the top-level (block) (depth 1) node for the current node.
  const currentBlockNodePos = $from.before(1);
  const currentNodeIndex = nodePositions.findIndex(
    pos => pos === currentBlockNodePos
  );

  const nextNodeIndex =
    direction === 'down' ? currentNodeIndex + 1 : currentNodeIndex - 1;

  // If we're already at the edge (first or last node), then the next node is out of bounds,
  // and there's nowhere to go.
  if (nextNodeIndex < 0 || nextNodeIndex >= nodePositions.length) {
    return false;
  }

  const nextNodePos = nodePositions[nextNodeIndex];
  const nextNode = state.doc.nodeAt(nextNodePos);

  // If the next node is a valid code suggestion node, programmatically shift focus
  // to its embedded editor. Simulating intuitive vertical navigation
  if (nextNode && isCodeSuggestionNode(nextNode)) {
    focusOnCodeSuggestionsEditor(nextNode.attrs.localId);
    return true;
  }
  // If the next node is not a code suggestion node, continue with default behavior.
  return false;
};

export const handlePMKeydownPlugin = () =>
  keymap({
    ArrowDown: (state: EditorState) => handleArrowNavigation(state, 'down'),
    ArrowUp: (state: EditorState) => handleArrowNavigation(state, 'up'),
  });
